export const CUSTOM_HAMPER_LOCAL_STORAGE_KEY = 'buildHamper';
export const CUSTOM_HAMPER_LOCAL_STORAGE_APP_KEY = 'buildHamperApp';
export const HAMPER_PAGE_SIZE = 20;
